import React from 'react';
import { ListUsers } from '~/components/Admin';

export function Users() {
    return <ListUsers />;
}
